module.exports = __webpack_public_path__ + "img/logo.2dad391.png";